var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressDashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 151,
    viewBox: "0 0 166 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.708 146.204C142.049 136.556 151.995 122.935 157.122 107.29C162.248 91.645 162.294 74.7791 157.25 59.107C152.207 43.4349 142.335 29.7604 129.046 20.0415C115.757 10.3226 99.7341 5.05759 83.2706 5.00047C66.8072 4.94334 50.7479 10.097 37.3921 19.7235C24.0363 29.35 14.0689 42.9556 8.91717 58.5923C3.76543 74.229 3.69351 91.0949 8.7117 106.775C13.7299 122.455 23.5809 136.145 36.8541 145.885",
    stroke: "#EEE2D7",
    strokeWidth: 10,
    strokeDasharray: "3 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressDashes);
export default __webpack_public_path__ + "static/media/progress-dashes.39c435977f597e52b497bf5f8daeeb6a.svg";
export { ForwardRef as ReactComponent };